(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["axvane-media-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('axvane-media-gallery')) {
  customElements.define('axvane-media-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.axvaneEvents) return;
      this.axvaneEvents = new AbortController();
      this.axvaneSlides = [...this.querySelectorAll('[data-axvane-gallery-slide]')];
      this.axvaneThumbs = [...this.querySelectorAll('[data-axvane-gallery-target]')];
      this.axvaneTrack = this.querySelector('[data-axvane-gallery-thumbs]');
      this.axvaneIndex = 0;
      this.axvaneMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.axvaneMediaVisible = typeof IntersectionObserver !== 'function';
      this.axvaneResumeVideo = null;
      const axvaneOptions = { signal: this.axvaneEvents.signal };
      this.addEventListener('click', axvaneEvent => {
        const axvaneThumb = axvaneEvent.target.closest('[data-axvane-gallery-target]');
        const axvaneStep = axvaneEvent.target.closest('[data-axvane-gallery-step]');
        if (axvaneThumb) this.axvaneSelect(Number(axvaneThumb.dataset.axvaneGalleryTarget));
        else if (axvaneStep) this.axvaneSelect(this.axvaneIndex + Number(axvaneStep.dataset.axvaneGalleryStep));
      }, axvaneOptions);
      this.addEventListener('keydown', axvaneEvent => {
        if (!['ArrowLeft', 'ArrowRight'].includes(axvaneEvent.key) || axvaneEvent.target.closest('video, input, textarea, select, [contenteditable]')) return;
        axvaneEvent.preventDefault();
        this.axvaneSelect(this.axvaneIndex + (axvaneEvent.key === 'ArrowRight' ? 1 : -1));
        this.axvaneThumbs[this.axvaneIndex]?.focus({ preventScroll: true });
      }, axvaneOptions);
      this.addEventListener('pointerdown', axvaneEvent => {
        if (axvaneEvent.pointerType === 'mouse' || axvaneEvent.isPrimary === false || axvaneEvent.target.closest('video, button, input, textarea, select, [data-axvane-gallery-thumbs]')) return;
        this.axvanePointer = { id: axvaneEvent.pointerId, x: axvaneEvent.clientX, y: axvaneEvent.clientY };
      }, axvaneOptions);
      this.addEventListener('pointerup', axvaneEvent => {
        const axvaneStart = this.axvanePointer;
        this.axvanePointer = null;
        if (!axvaneStart || axvaneStart.id !== axvaneEvent.pointerId) return;
        const axvaneX = axvaneEvent.clientX - axvaneStart.x;
        const axvaneY = axvaneEvent.clientY - axvaneStart.y;
        if (Math.abs(axvaneX) >= 38 && Math.abs(axvaneX) > Math.abs(axvaneY) * 1.35) this.axvaneSelect(this.axvaneIndex + (axvaneX < 0 ? 1 : -1));
      }, axvaneOptions);
      this.addEventListener('pointercancel', () => { this.axvanePointer = null; }, axvaneOptions);
      document.addEventListener('visibilitychange', () => this.axvaneSyncVideo(), axvaneOptions);
      this.axvaneMotion.addEventListener('change', () => this.axvaneSyncVideo(), axvaneOptions);
      if (typeof IntersectionObserver === 'function') {
        this.axvaneVisibilityObserver = new IntersectionObserver(axvaneEntries => {
          this.axvaneMediaVisible = axvaneEntries[0].isIntersecting && axvaneEntries[0].intersectionRatio > 0;
          this.axvaneSyncVideo();
        }, { threshold: [0, 0.01] });
        this.axvaneVisibilityObserver.observe(this.querySelector('[data-axvane-gallery-stage]') || this);
      }
      this.axvaneSelect(0, false);
    }
    axvaneSelect(axvaneIndex, axvaneInteract = true) {
      if (!this.axvaneSlides.length || !Number.isFinite(axvaneIndex)) return;
      const axvanePrevious = this.axvaneIndex;
      this.axvaneIndex = Math.max(0, Math.min(this.axvaneSlides.length - 1, axvaneIndex));
      if (axvanePrevious !== this.axvaneIndex || !axvaneInteract) this.axvaneResumeVideo = null;
      this.axvaneSlides.forEach((axvaneSlide, axvanePosition) => {
        axvaneSlide.hidden = axvanePosition !== this.axvaneIndex;
        if (!axvaneSlide.hidden) {
          const axvaneImage = axvaneSlide.querySelector('img');
          if (axvaneImage) axvaneImage.loading = 'eager';
        }
        const axvaneVideo = axvaneSlide.querySelector('video');
        if (!axvaneVideo) return;
        if (axvaneSlide.hidden || !axvaneInteract) axvaneVideo.pause();
        else if (axvanePrevious !== this.axvaneIndex && !this.axvaneMotion.matches) this.axvaneResumeVideo = axvaneVideo;
      });
      this.axvaneSyncVideo();
      this.axvaneThumbs.forEach((axvaneThumb, axvanePosition) => axvaneThumb.setAttribute('aria-current', String(axvanePosition === this.axvaneIndex)));
      const axvaneStatus = this.querySelector('[data-axvane-gallery-status]');
      if (axvaneStatus) axvaneStatus.textContent = (this.dataset.axvaneGalleryPosition || '{current} / {total}').replace('{current}', this.axvaneIndex + 1).replace('{total}', this.axvaneSlides.length);
      this.querySelectorAll('[data-axvane-gallery-step]').forEach(axvaneButton => {
        axvaneButton.disabled = Number(axvaneButton.dataset.axvaneGalleryStep) < 0 ? this.axvaneIndex === 0 : this.axvaneIndex === this.axvaneSlides.length - 1;
      });
      if (!axvaneInteract || !this.axvaneTrack) return;
      const axvaneThumb = this.axvaneThumbs[this.axvaneIndex];
      if (!axvaneThumb) return;
      const axvaneStart = this.axvaneTrack.scrollLeft;
      const axvaneEnd = axvaneStart + this.axvaneTrack.clientWidth;
      let axvaneLeft = axvaneStart;
      if (axvaneThumb.offsetLeft < axvaneStart) axvaneLeft = axvaneThumb.offsetLeft;
      else if (axvaneThumb.offsetLeft + axvaneThumb.offsetWidth > axvaneEnd) axvaneLeft = axvaneThumb.offsetLeft + axvaneThumb.offsetWidth - this.axvaneTrack.clientWidth;
      if (axvaneLeft !== axvaneStart) this.axvaneTrack.scrollTo({ left: axvaneLeft, behavior: this.axvaneMotion.matches ? 'auto' : 'smooth' });
    }
    axvaneSyncVideo() {
      const axvaneVideo = this.axvaneSlides[this.axvaneIndex]?.querySelector('video');
      if (!axvaneVideo) return;
      if (!this.axvaneMediaVisible || document.hidden || this.axvaneMotion.matches) {
        if (!axvaneVideo.paused) {
          this.axvaneResumeVideo = axvaneVideo;
          axvaneVideo.pause();
        }
        return;
      }
      if (this.axvaneResumeVideo === axvaneVideo) {
        this.axvaneResumeVideo = null;
        axvaneVideo.muted = true;
        axvaneVideo.play()?.catch(() => {});
      }
    }
    disconnectedCallback() {
      this.axvaneEvents?.abort();
      this.axvaneEvents = null;
      this.axvanePointer = null;
      this.axvaneVisibilityObserver?.disconnect();
      this.axvaneVisibilityObserver = null;
      this.axvaneResumeVideo = null;
      this.querySelectorAll('video').forEach(axvaneVideo => axvaneVideo.pause());
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
